import React from 'react';
import { OrderResponseDto } from 'client/widget-components/ecom/types/EcomSDK';
import {
    OrderViewHeader,
    OrderViewTitle,
    OrderViewSubtitle,
    OrderViewInvoiceNumber,
    OrderViewInvoiceNumberLabel,
    OrderViewInvoiceNumberValue,
} from '../styles';
import { useEcommStr } from '../useEcommStr';

interface OrderConfirmationHeaderProps {
    order: OrderResponseDto;
}

/**
 * Replicates the frontend OrderView confirmation header: a centered title,
 * subtitle and (when available) the invoice number. The continue-shopping
 * button from the Vue view is intentionally left out.
 */
const OrderConfirmationHeader: React.FC<OrderConfirmationHeaderProps> = ({
    order,
}) => {
    const str = useEcommStr();

    return (
        <OrderViewHeader data-auto='thank-you-for-your-order'>
            <div>
                <OrderViewTitle>
                    {str(
                        'nativeEcommRuntime.confirmation.thank_you_for_your_order'
                    )}
                </OrderViewTitle>
                <OrderViewSubtitle>
                    {str('nativeEcommRuntime.confirmation.subtitle')}
                </OrderViewSubtitle>
            </div>

            {order.invoice_number && (
                <OrderViewInvoiceNumber>
                    <OrderViewInvoiceNumberLabel>
                        {str('nativeEcommRuntime.cart.invoice_number')}:
                    </OrderViewInvoiceNumberLabel>
                    <OrderViewInvoiceNumberValue data-auto='order-invoice-number'>
                        {order.invoice_number}
                    </OrderViewInvoiceNumberValue>
                </OrderViewInvoiceNumber>
            )}
        </OrderViewHeader>
    );
};

export default OrderConfirmationHeader;
